module.exports = __webpack_public_path__ + "img/shopeepay.88749f47.png";